// /calls 상태 코드 → 라벨 / 색 매핑 (route-local 도메인 지식).

import type { StatusChipColor } from "components/list";

interface StatusMeta {
  label: string;
  color: StatusChipColor;
}

// IN / OUT 구분
export const inOutMeta: Record<string, StatusMeta> = {
  IN: { label: "IN", color: "info" },
  OUT: { label: "OUT", color: "warning" },
  ILUVIT: { label: "ILUVIT", color: "primary" },
};

// 콜 참여 상태(participation)
export const participationMeta: Record<string, StatusMeta> = {
  PARTICIPATION: { label: "참여", color: "primary" },
  COMPLETED: { label: "완료", color: "success" },
  HOLD: { label: "보류", color: "warning" },
  ABSENCE: { label: "부재", color: "default" },
  REJECT: { label: "거절", color: "error" },
};

// 매핑에 없는 값도 안전하게 표시
export const resolveStatusMeta = (
  map: Record<string, StatusMeta>,
  value: unknown
): StatusMeta => {
  const key = value === null || value === undefined ? "" : String(value);
  return map[key] ?? { label: key || "-", color: "default" };
};
